var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useContext } from 'react';
const CardContext = createContext(undefined);
function CardProvider(_a) {
    var { children } = _a, value = __rest(_a, ["children"]);
    return _jsx(CardContext.Provider, Object.assign({ value: value }, { children: children }));
}
function useCard() {
    return useContext(CardContext);
}
export { CardProvider, useCard };
